const externalLinks: Record<string, string> = {
    topdanmarkDK: 'https://www.topdanmark.dk/',
    topdanmarkInsurances: 'https://topdanmark.dk/forsikringer',
    insuranceFacts: 'https://www.topdanmark.dk/ipid/',
    insuranceConditions: 'https://www.topdanmark.dk/koebsbetingelser/private-forsikringer/',
    purchaseConditionsCVRAgriculture:
        'https://www.topdanmark.dk/landbrug/kobsbetingelser/landbrugsforsikringer-cvr/',
    infoProcessing: 'https://www.topdanmark.dk/saadan-anvender-vi-data/'
};

export { externalLinks };
